<template>
  <div>
    <v-btn
      color="warning"
      class="white--text"
      @click.stop="dialog = true"
      dark
      icon
      ><v-icon>mdi-pencil</v-icon></v-btn
    >
    <v-dialog v-model="dialog" persistent max-width="700">
      <v-card>
        <v-card-title>
          <span class="text-h5">Permission</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form">
              <v-row justify="center" align="center">
                <v-col cols="12" sm="3">role : </v-col>
                <v-col cols="12" sm="9"
                  ><v-text-field
                    v-model="pname"
                    outlined
                    dense
                    label="role"
                  ></v-text-field
                ></v-col>
              </v-row>

              <v-row
                v-for="(permission, i) in question_permission"
                :key="i"
                justify="center"
                align="center"
              >
                <v-col cols="12" sm="3">{{ i }} : </v-col>
                <v-col cols="12" sm="9">
                  <v-row no-gutters>
                    <v-col cols="12" v-if="!(typeof permission === 'object')">
                      <v-text-field
                        :value="permission"
                        outlined
                        dense
                        label="name"
                        @input="UpdateValue(i, $event)"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      v-else
                      v-for="(action, j) in permission"
                      :key="`${i}_${j}`"
                      cols="12"
                      sm="4"
                    >
                      <v-text-field
                        v-if="
                          typeof action === 'number' ||
                            typeof action === 'string'
                        "
                        v-model="permission[j]"
                        outlined
                        dense
                        label="name"
                      ></v-text-field>
                      <v-checkbox
                        v-if="typeof action === 'boolean'"
                        v-model="permission[j]"
                        :label="j"
                        hide-details=""
                        class="mt-0"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="validclose">
            ปิด
          </v-btn>
          <v-btn color="blue darken-1" text @click="EditPermision">
            บันทึก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
  props: ["permission"],
  data() {
    return {
      dialog: false,
      pname: "",
      question_permission: {
        // limitSurvey: 100,
        survey: {
          enableControl: true,
          // create: true,
          update: true,
          delete: true,
        },
        question: {
          create: true,
          update: true,
          delete: true,
        },
        report: {
          view: true,
          download: true,
        },
        account: {
          view: true,
          update: true,
          delete: true,
          createInvite: true,
          createRole: true,
        },
      },
    };
  },
  mounted() {
    this.question_permission = JSON.parse(
      JSON.stringify(this.permission.permission)
    );
    delete this.question_permission.survey.create;
    this.pname = this.permission.role;
  },
  methods: {
    UpdateValue(key, value) {
      this.question_permission[key] = value;
    },
    validclose() {
      this.dialog = false;
      this.question_permission = JSON.parse(
        JSON.stringify(this.permission.permission)
      );
      delete this.question_permission.survey.create;
      this.pname = this.permission.role;
    },
    EditPermision() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("UpdatePermission", {
            role: this.pname,
            roleID: this.permission.roleID,
            surveyID: this.$route.params.surveyID,
            permission: this.question_permission,
          })
          .then(() => {
            Swal.fire({
              icon: "success",
              text: "แก้ไขเรียบร้อยแล้ว",
              title: "",
              showConfirmButton: false,
              timer: 1500,
            }).then(() => {
              this.$store.dispatch("getPermission");
              this.dialog = false;
            });
          })
          .catch((error) => {
            console.log(error);
            Swal.fire({
              icon: "error",
              text:
                error.data.message === "role is duplicate"
                  ? "มีการใช้ชื่อนี้ไปแล้ว"
                  : error.data.message === "Permission Denied"
                  ? "คุณไม่มีสิทธิ์เข้าถึงการแก้ไข"
                  : "ไม่สามารถแก้ไขได้",
              title: "",
            }).then(() => {
              this.$store.dispatch("getPermission");
              this.$store.commit("ToggleLoading");
              if (error.data.message === "Permission Denied") {
                this.$store
                  .dispatch(
                    "getQuestionPermission",
                    this.$route.params.surveyID
                  )
                  .then(() => {
                    this.$router.push({
                      name: "question",
                    });
                  });
              }
            });
          });
      }
    },
  },
};
</script>
